import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useDispatch } from 'react-redux';
import {
  Box,
  Hidden,
  IconButton,
  Button,
  Typography,
  makeStyles,
  SvgIcon,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
} from '@material-ui/core';
import {
  Menu as MenuIcon
} from 'react-feather';
import { openSidebar } from 'src/actions/queueActions';
import { useParams } from 'react-router-dom';
import { useHistory } from 'react-router';
import axios from 'src/utils/axios';
import QueueEditNew from '../QueueEditNew';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(2),
    height: 68,
    display: 'flex',
    alignItems: 'center'
  },
  action: {
    marginLeft: 10
  }
}));

function Toolbar({
  className,
  queues,
  queueName,
  ...rest
}) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [editQueueOpen, setEditQueueOpen] = useState(false);
  const { queueId } = useParams();
  const editQueueRef = useRef();
  const history = useHistory();

  const [questionOpen, setQuestionOpen] = useState(false);
  const [questionTitle, setQuestionTitle] = useState('');
  const [questionMessage, setQuestionMessage] = useState('');

  const handleOpenSidebar = () => {
    dispatch(openSidebar());
  };

  const handleEditQueueClose = () => {
    setEditQueueOpen(false);
  };

  const handleSave = () => {
    editQueueRef.current.save();
    setEditQueueOpen(false);
  };

  const handleDeleteQueue = () => {
    setQuestionTitle('Delete Queue');
    setQuestionMessage('Are you sure you want to delete queue?');
    setQuestionOpen(true);
  };

  const handleQuestionClose = (answer) => {
    if (!answer) {
      setQuestionOpen(false);
      return;
    }

    if (questionTitle === 'Delete Queue') {
      axios.delete(`/api/queue/${queueId}`)
        .then(() => history.push('/app/queues'))
        .catch((error) => {
          console.error(error);
        });
    }
  };

  return (
    <div
      className={clsx(classes.root, className)}
      {...rest}
    >
      <Hidden mdUp>
        <IconButton onClick={handleOpenSidebar}>
          <SvgIcon fontSize="small">
            <MenuIcon />
          </SvgIcon>
        </IconButton>
      </Hidden>
      <Hidden smDown>
        <Box
          display="flex"
          alignItems="center"
        />
        <Typography
          variant="h3"
          color="textPrimary"
        >
          {queueName}
        </Typography>
        <Box flexGrow={1} />
        <Button
          variant="contained"
          className={classes.action}
          onClick={() => setEditQueueOpen(true)}
        >
          Edit queue
        </Button>
        <Button
          variant="contained"
          className={classes.action}
          onClick={handleDeleteQueue}
        >
          Delete queue
        </Button>

        <Dialog open={editQueueOpen} onClose={handleEditQueueClose} aria-labelledby="previewDialog" fullWidth maxWidth="lg">
          <DialogTitle id="previewDialog">
            Edit Queue
          </DialogTitle>
          <DialogContent>
            <QueueEditNew id={queueId} ref={editQueueRef} />
          </DialogContent>
          <DialogActions>
            <Button color="secondary" variant="contained" onClick={handleSave}>
              Save
            </Button>
            <Button onClick={handleEditQueueClose} color="primary">
              Cancel
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={questionOpen}
          onClose={() => handleQuestionClose(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{questionTitle}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {questionMessage}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => handleQuestionClose(true)} color="secondary" variant="contained">
              Yes
            </Button>
            <Button onClick={() => handleQuestionClose(false)} color="primary" autoFocus>
              No
            </Button>
          </DialogActions>
        </Dialog>

      </Hidden>
    </div>
  );
}

Toolbar.propTypes = {
  className: PropTypes.string,
  queueName: PropTypes.string,
  queues: PropTypes.number,
};

export default Toolbar;
